export const TOP_TIER_RETENTION = 'M1758695310';
export const HIGH_PERFORMER_RETENTION = 'M1778590010';
export const UNREGRETTED_ATTRITION = 'M1758697104';

export const PROJECTED_TTR = 'M1758696914';
export const PROJECTED_HPR = 'M1780571554';
export const PROJECTED_URA = 'M1758695849';

export const REGRETTED_ATTRITION = 'M1717789682';
export const TRANSFER_OUT = 'M1743540759';

export const widgetDisableChartFillForMetrics = new Set<string>([
  REGRETTED_ATTRITION,
  TRANSFER_OUT,
]);

export const widgetTooltipDescriptionTemplates: Record<string, string> = {
  [HIGH_PERFORMER_RETENTION]: 'Retained',
  [UNREGRETTED_ATTRITION]: 'Attrited',
  [REGRETTED_ATTRITION]: 'Attrited',
  [TRANSFER_OUT]: 'Transfers out',
};

export const metricIdToHoverTitle = new Map<string, string>([
  [HIGH_PERFORMER_RETENTION, 'Highest Performer Retention'],
  [UNREGRETTED_ATTRITION, 'Unregretted Attrition'],
  [REGRETTED_ATTRITION, 'Regretted Attrition %'],
  [TRANSFER_OUT, 'Transfer out %'],
]);

export const projectedTooltipText: Record<string, string> = {
  [PROJECTED_HPR]: 'Projected highest performer retention',
  [PROJECTED_URA]: 'Projected unregretted attrition',
};

export const projectedGapToGoalText: Record<string, string> = {
  [PROJECTED_HPR]: 'Projected highest performer retention',
  [PROJECTED_URA]: 'Projected unregretted attrition',
};

export const PERFORMANCE_YEAR_METRICS = [
  HIGH_PERFORMER_RETENTION,
  UNREGRETTED_ATTRITION,
  PROJECTED_HPR,
  PROJECTED_URA,
];

export const LEADER_MONTHLY_METRICS = [REGRETTED_ATTRITION, TRANSFER_OUT];
